import { IProfileForms } from "../components/profile/SettingsProfileComponent";
import { transformPrepation, transformOrderTypes } from "../utils/transforms";

import preperationForm from "../formSchemas/preperation.form";
import {
  collectionForm,
  deliveryForm,
  pickupForm,
  preOrderForm,
  orderingOptionsForm,
  deliveryFeeForm,
  autoAcceptForm,
  asapDeliveryForm,
  preciseLocationForm
} from "../formSchemas/ordertypes.form";
import collectionLimitsForm from "../formSchemas/collectionLimitsForm.form";
import {
  CollectionCustomLabel,
  DeliveryCustomLabel,
  DineInCustomLabel,
  PickupCustomLabel,
  VenueAreaRanges,
} from "../formSchemas/customLabel.form";
import homeDeliveryForm from "../formSchemas/homeDeliveryForm.form";
import { collectionPointResolver } from "../components/ordersSetting/Forms/Validation";

export const GeneralForm = (t: any, orderOnly: boolean): IProfileForms[] => {
  const formCollection = [
    {
      transformFunction: transformPrepation,
      formRows: preperationForm(t),
      title: "forms.orders.prep",
      formKey: "preperation",
      formButtonText: "forms.buttons.updateprep",
    },
    {
      transformFunction: transformOrderTypes,
      formRows: preOrderForm(),
      title: "forms.orders.PreOrder",
      formKey: "preOrder",
      formButtonText: "forms.buttons.updatePreOrder",
    },
  ];
  return orderOnly ? [{
    formRows: orderingOptionsForm(),
    title: "forms.orders.orderingOptions",
    formKey: "orderingOptions",
    formButtonText: "forms.buttons.updateOrderingOptions",
  }, ...formCollection] : formCollection
};

export const OrderTypesDinInForm = (
  t: (value: string) => string
): IProfileForms[] => {
  return [
    {
      formRows: VenueAreaRanges,
      title: "",
      formKey: "orderLocationsGroups",
    },
    {
      formRows: DineInCustomLabel,
      title: "",
      formKey: "dineInCustomLabel",
    },
  ];
};
export const OrderTypesCollection = (
  isDisabled: boolean
): IProfileForms[] => {
  return [
    {
      transformFunction: transformOrderTypes,
      formRows: collectionForm(isDisabled),
      title: "forms.orders.ordertypes",
      formKey: "orderTypes",
      formButtonText: "forms.buttons.updateCollectionOrder",
    },
    {
      formRows: CollectionCustomLabel,
      title: "",
      formKey: "collectionCustomLabel",
    },
    {
      formRows: collectionLimitsForm,
      title: "",
      formKey: "orderCollectionLimits",
    },
  ];
};
export const OrderTypesDelivery = (
  showRadius: boolean,
  onPressSetLocation: () => void,
  hasSetLocation: boolean,
  isUkVenue: boolean
): IProfileForms[] => {
  let rows = [
    {
      transformFunction: transformOrderTypes,
      formRows: deliveryForm(showRadius),
      title: "forms.orders.ordertypes",
      formKey: "orderTypes",
      formButtonText: "forms.buttons.updateDeliveryOrder",
    },
    {
      formRows: deliveryFeeForm(),
      title: "forms.orders.deliveryFeeSettings",
      formKey: "delivery_fees",
      formButtonText: "forms.buttons.updateDeliveryOrder",
    },
    {
      formRows: DeliveryCustomLabel,
      title: "",
      formKey: "deliveryCustomLabel",
    },
    {
      formRows: homeDeliveryForm,
      title: "",
      formKey: "homeDeliveryForm",
    },
  ];

  if (isUkVenue) {
    rows.splice(1, 0, {
      formRows: preciseLocationForm(onPressSetLocation, hasSetLocation),
      title: "",
      formKey: "precise_location",
    })
  }

  return rows
};
export const OrderTypesPickup = (isDisabled: boolean, t: any) => {
  return [
    {
      formRows: pickupForm(isDisabled),
      title: "forms.orders.pickupnow",
      formKey: "orderTypes",
      formButtonText: "forms.buttons.updatePickNow",
      resolver: (data: any) => collectionPointResolver(data, t)
    },
    {
      formRows: PickupCustomLabel,
      title: "",
      formKey: "deliveryCustomLabel",
    },
  ]
}
export const NewOrdersAutoAccept = () => {
  return [
    {
      formRows: autoAcceptForm(),
      title: "forms.orders.autoAccept.title",
      formKey: "newOrdersAutoAccept",
      formButtonText: "forms.orders.autoAccept.update",
    }
  ]
}

export const ASAPDeliveryOption = () => {
  return [
    {
      formRows: asapDeliveryForm(),
      title: "forms.orders.AsapDelivery.title",
      formKey: "asapDelivery",
      formButtonText: "forms.orders.AsapDelivery.update",
    }
  ]
}
